import { AgenturModel } from 'app/models/agentur.model';
import { AgenturStore } from '../agentur.store';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import _ from 'lodash';
import { BaseUiStore } from './base.ui.store';
import { StsModel, AgtStsStore } from '../agt.sts.store';

export class StsVM {
	agt: AgenturModel;
	@observable
	sts: StsModel[];

	constructor(agt: AgenturModel, sts: StsModel[]) {
		makeObservable(this);
		this.agt = agt;
		this.sts = sts;
	}

	@computed
	get sts4Adz() {
		if (this.sts.length === 0) {
			return [];
		}
		let sorted = _.orderBy(this.sts, ['bid', 'bm'], ['desc']);
		sorted = _.filter(sorted, (s) => s.bm >= 202512);
		return sorted;
	}

	@computed
	get latestSts() {
		if (this.sts.length === 0) {
			return null;
		}
		const sorted = _.orderBy(this.sts, ['bm'], ['desc']);
		return sorted[0];
	}

	@computed
	get basicSchulung() {
		if (this.latestSts) {
			return this.latestSts.basicPercent;
		}

	}

	@computed
	get mcSchulung() {
		if (this.latestSts) {
			return this.latestSts.mc;
		}
	}
}

export class AgtStsUiStore extends BaseUiStore<StsVM> {
	name = 'AgtStsUiStore';
	agtStsStore: AgtStsStore;
	agenturStore: AgenturStore;

	constructor(agenturStore: AgenturStore, agtStsStore: AgtStsStore) {
		super();
		makeObservable(this);
		this.agtStsStore = agtStsStore;
		this.agenturStore = agenturStore;
	}

	getByAgtId(agtId: number): StsVM[] {
		return this.items.filter((i) => i.agt.agtId === agtId);
	}

	async _baseLoad() {
		const data = await this.agtStsStore.loadAll();
		const agts = await this.agenturStore.findAll();
		const res: StsVM[] = [];
		for (const agt of agts) {
			let stsItems = data.filter((d) => d.agtId === agt.agtId);
			stsItems = _.filter(stsItems, (s) => s.bm >= 202512);
			if (stsItems.length > 0) {
				const vm = new StsVM(agt, stsItems);
				res.push(vm);
			}
		}
		runInAction(() => {
			this.items = res;
		});
	}
}
